import ContactsDuplicates from '../../../store/contacts/duplicates';

angular
    .module('festzelt-os.guestlists')
    .factory('ContactDuplicates', [
        '$injector',
        'Contact',
        ($injector, Contact) => {
            return {
                create(name) {
                    return new ContactsDuplicates(name, Contact, {
                        injector: $injector
                    });
                }
            }
        }
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/contacts/store/contact-duplicates.js